import { useEffect, useState } from "react";
import * as React from 'react';
import {
  Box,
  Button,
  InputAdornment,
  LinearProgress,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Field, Form, Formik, useFormik } from "formik";
import axios from "axios";
import auth from "../route_rules/auth";
import Logo from "../assets/images/VBM_LOGO_FULL.png";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import SpaTwoToneIcon from "@mui/icons-material/SpaTwoTone";
import Autocomplete from "@mui/material/Autocomplete";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import TocIcon from '@mui/icons-material/Toc';
import GridOnIcon from '@mui/icons-material/GridOn';
import ExposureIcon from '@mui/icons-material/Exposure';
import HouseIcon from '@mui/icons-material/OtherHouses';
import UploadIcon from '@mui/icons-material/FileUpload';
import UserIcon from '@mui/icons-material/PeopleAlt';
import GrassIcon from '@mui/icons-material/Grass';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import SettingsIcon from '@mui/icons-material/Settings';
import Grow from '@mui/material/Grow';
import { Style } from "util";
import { PropTypes } from "@mui/material";
import SprayIcon from '@mui/icons-material/Shower';
import { IApplication } from "../interfaces/IApplication";
import { setApplicationValues, setPageTitle } from "../slices/applicationSlice";
import { useAppSelector, useAppDispatch } from "../hooks";
import ShippingIcon from '@mui/icons-material/LocalShipping';
import InvoiceIcon from '@mui/icons-material/RequestPage';
import ReceiptIcon from '@mui/icons-material/ReceiptLong';
import SignpostIcon from '@mui/icons-material/Signpost';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#666666' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  export default function ModuleMenu() {
    const dispatch = useAppDispatch();
    useEffect(() => {
  
      let appState: IApplication = {
        pageTitle: "Main Dashboard",
        backgroundPath: "../assets/images/loginbg.jpg"
      }
      dispatch(setPageTitle(appState));
    }, []);
  
    const [open, setOpen] = React.useState(false);
  
    const handleClickOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };
  
  
    const [errorMessage, setErrorMessage] = useState({ error: "" });
    let items = [];
    let history = useNavigate();
  
    const Item = styled(Paper)(({ theme }) => ({
      backgroundColor: theme.palette.mode === "dark" ? "#999" : "#fff",
      ...theme.typography.body2,
      padding: theme.spacing(1),
      textAlign: "center",
      color: theme.palette.text.secondary,
    }));
  
  
    const moduleChanged = (event: any, newValue: any | null) => {
      console.log(newValue);
      navigate(newValue.route);
    };
  
    const navigate = useNavigate();
  
    const darkTheme = createTheme({
      palette: {
        mode: 'dark',
        primary: {
          main: '#FFF',
        },
      },
    });
  
    return (
        <DialogContent>
            <Grid container spacing={1} sx={{ padding: 2 }}>
              <Grid item xs={12} md={3}>
                <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                  <Button
                    sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<SpaTwoToneIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                    onClick={() => navigate("/patching/dashboard")}
                  >
                    <Typography variant="h5" fontWeight="700">PATCHING</Typography>
                  </Button>
                </Item>
              </Grid>
              <Grid item xs={12} md={3}>
                <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                  <Button
                    sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<HouseIcon sx={{ width: 45, height: 45, color: "#89B219" }} />}
                    onClick={() => navigate("/main/spaceallocationdashboard")}
                  >
                    <Typography variant="h5" fontWeight="700">SPACE ALLOCATION</Typography>
                  </Button>
                </Item>
              </Grid>
              <Grid item xs={12} md={3}>
                <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                  <Button
                    sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<UploadIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                    onClick={() => navigate("/main/trayimportdashboard")}
                  >
                    <Typography variant="h5" fontWeight="700" sx={{}}>TRAY IMPORT</Typography>
                  </Button>
                </Item>
              </Grid>
              <Grid item xs={12} md={3}>
                <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                  <Button
                    sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<UserIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                    onClick={() => navigate("/hr/usersdashboard")}
                  >
                    <Typography variant="h5" fontWeight="700" sx={{}}>USER MANAGEMENT</Typography>
                  </Button>
                </Item>
              </Grid>
              <Grid item xs={12} md={3}>
                <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                  <Button
                    sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<GrassIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                    onClick={() => navigate("/main/inventorydashboard")}
                  >
                    <Typography variant="h5" fontWeight="700" sx={{}}>INVENTORY</Typography>
                  </Button>
                </Item>
              </Grid>
              <Grid item xs={12} md={3}>
                <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                  <Button
                    sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<SprayIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                    onClick={() => navigate("/main/growingdashboard")}
                  >
                    <Typography variant="h5" fontWeight="700" sx={{}}>GROWING</Typography>
                  </Button>
                </Item>
              </Grid>
              <Grid item xs={12} md={3}>
                <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                  <Button
                    sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<SignpostIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                    onClick={() => navigate("/logistics/dashboard")}
                  >
                    <Typography variant="h5" fontWeight="700" sx={{}}>LOGISTICS</Typography>
                  </Button>
                </Item>
              </Grid>
              <Grid item xs={12} md={3}>
                <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                  <Button
                    sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                    fullWidth
                    variant="contained"
                    size="large"
                    startIcon={<InvoiceIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                    onClick={() => navigate("/invoicing/dashboard")}
                  >
                    <Typography variant="h5" fontWeight="700" sx={{}}>INVOICING</Typography>
                  </Button>
                </Item>
              </Grid>
              <Grid item xs={12} md={3}>
                      <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                        <Button
                          sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                          fullWidth
                          variant="contained"
                          size="large"
                          startIcon={<ShippingIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                          onClick={() => navigate("/shipping/dashboard")}
                        >
                          <Typography variant="h5" fontWeight="700" sx={{}}>SHIPPING</Typography>
                        </Button>
                      </Item>
                </Grid>
                <Grid item xs={12} md={3}>
                      <Item sx={{ padding: 0, bgcolor: 'transparent', boxShadow: 'none' }}>
                        <Button
                          sx={{ minHeight: 120, borderRadius: '20px', boxShadow: 12, border: "2px solid #FFF" }}
                          fullWidth
                          variant="contained"
                          size="large"
                          startIcon={<ReceiptIcon sx={{ width: 55, height: 55, color: "#89B219" }} />}
                          onClick={() => navigate("/po/podashboard")}
                        >
                          <Typography variant="h5" fontWeight="700" sx={{}}>PURCHASE ORDERS</Typography>
                        </Button>
                      </Item>
                </Grid>
            </Grid>
            </DialogContent>
    );
  }
  